module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.asset.get("persisted")) {
        $o.push("<div class='" + (['js-sticky-section', "" + ($e($c((this.asset.get("allowDelete") ? "delete-contained delete-confirmation-wrapper delete-overlay" : void 0))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n  <div class='flex-fixed flex-v-center flex-wrapper js-sticky-bar'>\n    <div class='flex-column' notranslate>");
        $o.push("      " + $e($c(this.asset.get("title") || this.asset.get("name"))));
        $o.push("    </div>\n    <div class='actions flex-column'>\n      <div class='dropdown-align-right dropdown-container dropdown-grouped-lines js-asset-actions'>\n        <div class='button dropdown-ellipsis-toggle small'></div>\n        <ul class='dropdown-selection'>\n        <li>\n        <a class='js-download-asset' href='" + ($e($c(this.asset.get("url")))) + "' download title='Download'>Download</a>\n        </li>");
        if (this.asset.get("allowDelete")) {
          $o.push("        <li>\n        <a href='javascript:;' data-behavior='confirm-delete'>Delete image</a>\n        </li>");
        }
        $o.push("        </ul>\n      </div>\n    </div>\n  </div>\n  <div class='delete-confirmation-wrapper delete-overlay image-container img-annotator-container js-images-container'>\n    <img class='js-image' src='" + ($e($c(this.asset.get("url")))) + "' width='100%' data-asset-id='" + ($e($c(this.asset.get("asset_id")))) + "'>\n  </div>");
        if (this.asset.get("allowDelete")) {
          $o.push("  " + $c(this.AssetDeleteConfirmationTemplate()));
        }
        $o.push("</div>");
      } else if (this.asset.get("processing")) {
        $o.push("<span class='icon icon-spinner js-processing'>Processing</span>");
      } else {
        $o.push("<span class='button js-attach secondary small'>Add image</span>");
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/story/templates/assets/image_field.js.hamlc
// module id = 1374
// module chunks = 17